"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListCondition = exports.ListCountType = void 0;
const condition_1 = require("./condition");
const join_condition_1 = require("./join-condition");
const _ = __importStar(require("lodash"));
const list_field_1 = require("./list-field");
var ListCountType;
(function (ListCountType) {
    ListCountType[ListCountType["atLeast"] = 0] = "atLeast";
    ListCountType[ListCountType["atMost"] = 1] = "atMost";
    ListCountType[ListCountType["exactly"] = 2] = "exactly";
})(ListCountType || (exports.ListCountType = ListCountType = {}));
class ListCondition extends condition_1.Condition {
    getCountDescription() {
        return this.countTypeMapping[this.countType] + "" + this.count;
    }
    constructor(name) {
        super(name || "Nested Condition");
        this.countType = ListCountType.atLeast;
        this.count = 1;
        this.condition = new join_condition_1.JoinCondition();
        this.countField = '';
        this.countTypeMapping = {
            0: "≥",
            1: "≤",
            2: "=",
        };
    }
    static atLeast(listAccessor, condition, count = 1) {
        let listCondition = new ListCondition();
        return _.extend(listCondition, {
            listAccessor,
            listAccessorDisplay: listAccessor,
            countType: ListCountType.atLeast,
            count,
            condition,
        });
    }
    static exactly(listAccessor, condition, count = 0) {
        let listCondition = new ListCondition();
        return _.extend(listCondition, {
            listAccessor,
            listAccessorDisplay: listAccessor,
            countType: ListCountType.exactly,
            count,
            condition,
        });
    }
    static createRuleAssistCondition(node, objChildren) {
        let listCondition = new ListCondition();
        listCondition.listAccessor = node.accessor;
        listCondition.listAccessorDisplay = node.display;
        listCondition.listFields = new list_field_1.ListField();
        listCondition.listFields.fields = node.fields;
        listCondition.listFields.listFields = node.listFields;
        listCondition.condition.set(objChildren);
        return listCondition;
    }
}
exports.ListCondition = ListCondition;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/casa-rules-v2/list-condition.js
// module id = 1243
// module chunks = 0